var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center loading-container",class:{'inside-container': _vm.insideContainer}},[_c('div',{attrs:{"id":"loader"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }